import {type DataRouterFilePagePayload, isFileOverviewPayload} from '@github-ui/code-view-types'
import {getQueryClient} from '@github-ui/react-core/query-client'
import {useMatches} from '@github-ui/react-router'

import {codeViewRepoRoute} from '../routes/code-view-repo-route'
import {codeViewTreeRoute} from '../routes/code-view-tree-route'

/**
 * Determines if the current view is an overview page.
 */
export function useIsOverview() {
  const matches = useMatches()
  const overviewMatch = matches.some(match => match.id === codeViewRepoRoute.id)
  const treeMatch = matches.find(match => match.id === codeViewTreeRoute.id)

  // Repo route is always overview
  if (overviewMatch) return true

  // Tree route - check payload type from query cache
  if (treeMatch) {
    const queryClient = getQueryClient()
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const queryKey = (treeMatch.loaderData as any)?.queries?.mainQuery?.queryConfig?.queryKey
    const data = queryClient.getQueryData(queryKey) as {payload: DataRouterFilePagePayload}
    return data ? isFileOverviewPayload(data.payload) : false
  }

  return false
}
